<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormSubunidadmaterial" role="form" method="post" autocomplete="off" onSubmit="return false">
				
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="Cantidad">Cantidad</label>
							<input type="text" v-model="objSubunidadmaterial.Cantidad" class="form-control" id="Cantidad" placeholder="Ingresar Cantidad" @input="$onlyNums($event,objSubunidadmaterial,'Cantidad')"/>
							<CValidation v-if="this.errorvalidacion.Cantidad" :Mensaje="'*'+errorvalidacion.Cantidad[0]"/>
						</div>

                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="SubUnidad">Sub Unidad</label>
							<input disabled type="text" v-model="objSubunidadmaterial.SubUnidad" class="form-control" id="SubUnidad" placeholder="Ingresar SubUnidad"/>
							<CValidation v-if="this.errorvalidacion.SubUnidad" :Mensaje="'*'+errorvalidacion.SubUnidad[0]"/>
						</div>
					</div>
											
					<br>
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormSubunidadmaterial',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objSubunidadmaterial: {
				IdSubUnidadMaterial: 0,
				IdUnidadMaterial: 0,
				Cantidad: 0,
				SubUnidad: '',
				
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
			this.poBtnSave.Toast = 0; 
			this.poBtnSave.DisableBtn = true;

			if(this.objSubunidadmaterial.IdSubUnidadMaterial == 0) {
				await this.$http.post(
					'subUnidadesMaterial',this.objSubunidadmaterial
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'subUnidadesMaterial/'+this.objSubunidadmaterial.IdSubUnidadMaterial,
					this.objSubunidadmaterial
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "subUnidadesMaterial/"+this.objSubunidadmaterial.IdSubUnidadMaterial
            ).then((res) => {
                this.objSubunidadmaterial = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objSubunidadmaterial.Fecha.replace(/-/g,'\/');
                this.objSubunidadmaterial.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objSubunidadmaterial = {
				IdSubUnidadMaterial: 0,
				IdUnidadMaterial: 0,
				Cantidad: 0,
				SubUnidad: '',
				
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();

			let ObjUnidadmaterial = JSON.parse(sessionStorage.getItem('objUnidadmaterial'));
			this.objSubunidadmaterial.IdUnidadMaterial = ObjUnidadmaterial.IdUnidadMaterial;
            this.objSubunidadmaterial.SubUnidad=ObjUnidadmaterial.SubUnidad;
                
            if (Id!='') 
            {
                this.objSubunidadmaterial.IdSubUnidadMaterial = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
